export default {
    400: {
        title: "Złe żądanie",
        header: "@:views.errors.400.title",
        html: "Błędne żądanie. Spróbuj ponownie później."
    },
    401: {
        title: "Wystąpił błąd podczas logowania",
        header: "@:views.errors.401.title",
        html: "Skontaktuj się z <a href='{email}' target='_blank'>pomocą techniczną</a> ."
    },
    404: {
        title: "Strona nie znaleziona",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Dostęp niedozwolony",
        header: "Dostęp niedozwolony",

        contact: "O-I Urządzenia peryferyjne są dostępne tylko dla pracowników. Jeśli jesteś pracownikiem i widzisz ten komunikat, skontaktuj się z lokalnym Działem Kadr i Kultury, aby zaktualizować swój status.",

        subject: "Sprzęt - Kwalifikowalność",

        html: "<p class='text-start'>@:views.errors.403.eligibility @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Obecnie nie kwalifikujesz się. Skontaktuj się z <a href='#' role='button' data-widget-trigger='{widgetOptions}'>pomocą techniczną</a> , aby uzyskać więcej informacji.</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Obecnie nie kwalifikujesz się. Skontaktuj się z lokalnym Działem ds. Ludzi i Kultury, aby uzyskać więcej informacji.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Urządzenia peryferyjne są dostępne tylko dla pracowników. Jeśli jesteś pracownikiem i widzisz ten komunikat, skontaktuj się z lokalnym Działem Kadr i Kultury, aby zaktualizować swój status.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>W Twoim profilu ServiceNow nie ma aktywnego menedżera. Skontaktuj się z lokalnym przedstawicielem Działu Kadr i Kultury, aby zaktualizować dane swojego menedżera.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>W Twoim profilu ServiceNow Twój menedżer jest ustawiony jako Ty. Skontaktuj się z lokalnym przedstawicielem Działu Kadr i Kultury, aby zaktualizować ustawienia menedżera.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Nie masz podanej lokalizacji w swoim profilu ServiceNow. Skontaktuj się z lokalnym przedstawicielem Działu Kadr i Kultury, aby zaktualizować swoją lokalizację.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I Urządzenia peryferyjne są dostępne tylko dla pracowników. Jeśli jesteś pracownikiem i widzisz ten komunikat, skontaktuj się z lokalnym Działem Kadr i Kultury, aby zaktualizować swój status.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Dziękujemy za zainteresowanie O-I Peripheral. Obecnie ten program nie jest dostępny w Twoim kraju.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Próbujesz uzyskać dostęp do O-I Peripheral na koncie dodatkowym. Spróbuj zalogować się ponownie, używając konta głównego.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Twoje konto ServiceNow nie ma nazwy. Skontaktuj się z lokalnym przedstawicielem Działu Kadr i Kultury, aby zaktualizować swoje konto.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.eligibility @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Dostęp wzbroniony",
                subject: "Dostęp wzbroniony",
                html: "Nie masz uprawnień do otwarcia tej strony.",
            },
            "virtual-denied": {
                header: "Wygląda, że przyszedłeś trochę za wcześnie...",
                html: "<p class='text-start'>Dziękujemy za zainteresowanie O-I Peripheral. Wygląda na to, że dotarłeś do witryny przed włączeniem i bezpośrednim zaproszeniem. O-I Peripheral jest wdrażany etapami w poszczególnych krajach i grupach użytkowników. Po aktywacji otrzymasz wiadomość e-mail z osobistym zaproszeniem i instrukcjami.</p><p class='text-start'> Kliknij na <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Wsparcie</a> , jeśli masz pytania lub problemy dotyczące zamówienia lub witryny.</p>",
            }
        }
    },
    500: {
        title: "Nieoczekiwany błąd",
        header: "@:views.errors.500.title",
        message: "Wystąpił błąd. Spróbuj ponownie później."
    },
    code: {
        title: "Nieoczekiwany błąd",
        message: "@:views.errors.code.title",
        error: "Błąd {code}."
    }
}